import { Injectable } from "@angular/core";
import { IInstanceService } from "app/+common/contracts/instance-service.contract";
import { BaseService } from "app/+common/contracts/base-service.contract";
import { Instance } from "app/+core/common/model/instance.model";
import { Observable } from 'rxjs/Observable';
import { HttpClient } from "@angular/common/http";
import { Http } from "@angular/http";

@Injectable()
export class InstanceService extends BaseService implements IInstanceService
{
    constructor(private http: HttpClient, private httpOld: Http)
    {
        super();

        this.httpOld.get('assets/configuration/environment.json')
            .map(res => res.json())
            .toPromise()
            .then((config:any) =>
            {
                this.backendUrl = config.url;
                this.instanceType = config.env;
                localStorage.setItem("exaco-instance-type", config.env);
                localStorage.setItem("exaco-instance-module", config.module);
                localStorage.setItem("backendURL", config.url);

                console.log(config.url);
                console.log(config.env);
            });

        // this.http
        //     .get<Instance>(this.backendUrl + 'instances/0')
        //     .map(this.extractData)
        //     .catch(this.handleError)
        //     .subscribe(res => 
        //         { 
        //             if ((res as Instance).url.length > 0) 
        //                 localStorage.setItem("exaco-instance-type", "master"); 
        //             else
        //                 localStorage.setItem("exaco-instance-type", "base");
        //         });
    }

    getInstanceList(): Observable<Instance[]>
    {
        return this.http
            .get(this.backendUrl + 'instances')
            .map(this.extractData)
            .catch(this.handleError);
    }

    isInstanceMaster(): boolean
    {
        return localStorage.getItem("exaco-instance-type") === "master";
    }

    isInstanceCatering(): boolean {
        return localStorage.getItem("exaco-instance-module") === "catering";
    }
}


// WEBPACK FOOTER //
// ./src/app/+master-data/common/services/instance-service.ts